import {
  Directive,
  ElementRef,
  Input,
  inject,
} from '@angular/core';

@Directive({
  selector: '[libScrollIntoViewIfActive]',
  standalone: true,
})
export class ScrollIntoViewIfActiveDirective {
  private readonly el = inject(ElementRef<HTMLElement>);

  @Input('libScrollIntoViewIfActive')
  set active(value: boolean) {
    if (value) this.scrollIntoView();
  }

  private scrollIntoView() {
    queueMicrotask(() =>
      this.el.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
    );
  }
}
